import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../data/static/strings'
import { updateEndDateTimeInRequest } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
import { refundParserTxnV3, refundParserTxnV3New } from './parsers/RefundsParserTxnV3'

const responseParser = (data: any, type: any, transactionTabName: string) => {
  if (transactionTabName !== 'Transactions' && transactionTabName !== 'Home') {
    const respData = refundParserTxnV3New(data?.data, type)
    return respData
  } else {
    const respData = refundParserTxnV3(data?.data, type)
    return respData
  }
}

const getRefundsReqV3 = (
  tokens: any,
  userAccessToken: string,
  requestBody: any,
  type: any,
  isCustomFromRecents = false,
  transactionTabName = '',
  selectedDateInfo: any = null,
  abortController: any = null
) => {
  const isCustomRange = selectedDateInfo.dateLabel === actionMenuStrings.customDate
  const isInfiniteDateScroll = selectedDateInfo?.dateLabel === actionMenuStrings.infiniteScrollRange
  //|| RootStore.transactions.selectedDateInfo.dateLabel === actionMenuStrings.yesterday
  const request: Request<{}> = {
    apiPath: APIEndPoints.TransactionsV3,
    method: 'POST',
    config: sitConfig(tokens, abortController),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body:
      isCustomRange || isCustomFromRecents || isInfiniteDateScroll
        ? requestBody
        : updateEndDateTimeInRequest(requestBody, selectedDateInfo),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data, type, transactionTabName)
  })
}

const getSearchByRefundList = (
  tokens: any,
  userAccessToken: string,
  rrn: string,
  type: any,
  mid: string,
  txnType: any,
  isSmid: boolean,
) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.txnDetailsV3,
    method: 'POST',
    config: sitConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body: {
      inputFilter: {
        merchantId: mid,
        transactionType: type,
        transactionId: [rrn],
        responseType: 'ALL',
        isSMID: isSmid ? 'Y' : 'N',
      },
      configParams: {
        mediaType: 'JSON',
      },
    },
    cache: false,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data, txnType, 'Refund History')
  })
}

export { getRefundsReqV3, getSearchByRefundList }
